import React, { useContext } from "react";
import { UserContext } from "../usercontext/usercontext";


// AccessComponent definition
const AccessComponent = ({ name, action, children }) => {

   const { user } = useContext(UserContext);

   const accessData = user?.permission //actual role base access

  // Find the access entry by name
  const accessEntry = accessData?.find((entry) => entry.name === name);

  // Check if the action is allowed
  const isAllowed = accessEntry?.access.includes(action);

  // Render children based on access
  return (
    <div style={{ display: isAllowed ? "block" : "none" }}>{children}</div>
  );
};

export default AccessComponent;
